import CloseModalButton from './CloseModalButton'

export default CloseModalButton;



// WEBPACK FOOTER //
// ./src/components/CloseModalButton/index.js